import { connect } from "react-redux";
import Input from "../Input";
import { fetchHashtags } from "../actions";

export const getHashtagsFromString = string => {
  const output = string
    .replace(/#/g, " ")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
  return output;
};

export const mapStateToProps = state => {
  return {
    value: state.inputs.join(" "),
    isFetching: state.isFetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: value => {
      const values = [getHashtagsFromString(value)];
      dispatch({ type: "ON_INPUT_CHANGE", query: values });
    },
    onSearch: value => {
      const values = getHashtagsFromString(value);
      dispatch(fetchHashtags(values));
    }
  };
};

// Container Component
const CurrentInput = connect(mapStateToProps, mapDispatchToProps)(Input);

export default CurrentInput;



// WEBPACK FOOTER //
// ./src/containers/CurrentInput.js